import {BaseApiTemplateService, PagingResponseModel, ApiVisa} from '../../shared';
import {MembershipAttachmentContainerModel} from '../../../../../../models/aggregates/crm/membership-attachment';
import {Core2Config} from '../../shared';
import {HttpClient} from '@angular/common/http';
import {Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class MembershipAttachmentService extends BaseApiTemplateService<MembershipAttachmentContainerModel>{

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/attachments';

    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/attachments';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/attachments';
      this.httpClient = http;
    }

    getFile(guid: string, visa: ApiVisa): Observable<Blob> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path + '/file/' + guid;
      }
  
      return this.httpClient.get<Blob>(this.apiUrl, this.getHttpHeaderBlob(visa));
    }

}